import React, { useEffect } from "react";
import Components from "./components/Components";
import ScrolToTop from "./components/Elements/ScrolToTop";
import Loader from "./components/Elements/Loader";

const App = () => {
  useEffect(() => {
    const loaderSc = document.querySelector(".loading-area");
    setTimeout(() => {
      loaderSc.classList.add("loading-hidden");
    }, 1000);
  }, []);

  return (
    <div className="App">
      <Loader />
      <Components />
      <ScrolToTop />
    </div>
  );
};

export default App;
